import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import LabelAndSelectChange from '../form/labelAndSelectChange';

import { getGrupoFisicoList } from './selectdbAtions';

class SelectGrupoFisicoUsuario extends Component {
  componentWillMount() {
    this.props.getGrupoFisicoList();
  }

  renderOptions() {
    const list = this.props.list || [];

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    // Adiciona opção "Todos" no início da lista
    const options = [
      <option key="todos" value="">
        Todos os Grupos Físicos
      </option>
    ];

    // Adiciona os grupos físicos específicos
    list.forEach(grupo => {
      options.push(
        <option key={grupo.id} value={grupo.id}>
          {grupo.id} - {grupo.descricao}
        </option>
      );
    });

    return options;
  }

  render() {
    return (
      <LabelAndSelectChange
        id={this.props.id}
        name={this.props.name}
        label={this.props.label}
        cols={this.props.cols}
        onChange={this.props.onChange}
        value={this.props.value}
        disabled={this.props.disabled}
      >
        {this.renderOptions()}
      </LabelAndSelectChange>
    );
  }
}

const mapStateToProps = state => ({ list: state.grupoFisicoCad.list });
const mapDispatchToProps = dispatch => bindActionCreators({ getGrupoFisicoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectGrupoFisicoUsuario);
